import React from 'react';
import './Switch.scss';

type SwitchProps = {
  isOn: boolean;
  onToggle: (isOn: boolean) => void;
};
const Switch = (props: SwitchProps) => {
  const { isOn, onToggle } = props;
  return (
    <div className={`switch ${isOn ? 'on' : 'off'}`} onClick={() => onToggle(isOn)}>
      <div className="toggle" />
    </div>
  );
};

export default Switch;
